import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Text } from '@pinpoint/design-kit';

import BaseDialog from './base';
/* eslint-disable react/prop-types */

function DeleteDialog({ isOpen, actions }) {
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={actions}
      title={{
        text: `Delete Config`,
        backgroundColor: 'marigold',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          <Text key="rt-delete-question" textSize="paragraph" textWeight="500" textColor="shade66">
            Are you sure you want to delete this config?
          </Text>,
        ],
        buttons: [
          {
            text: 'YES',
            textSize: 'body',
            close: true,
          },
        ],
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
DeleteDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }),
};
/* eslint-enable */

export default DeleteDialog;
